import { DependencyList, MutableRefObject, useEffect, useMemo } from "react"

const useOnClickOutside = <T extends HTMLElement | null>(
    callback: () => void,
    refs: Array<HTMLElement | Element | null | MutableRefObject<T>>,
    dependencies?: DependencyList
) => {
    const deps = useMemo(() => [...(refs || []), ...(dependencies || [])], [refs, dependencies])

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (refs.length === 0) return
            if (
                refs.every(
                    r =>
                        r &&
                        ("current" in r
                            ? r.current && !r.current.contains(event.target as Node)
                            : !r.contains(event.target as Node))
                ) &&
                !(
                    event.target === document.getElementsByTagName("html")[0] &&
                    event.clientX >= document.documentElement.offsetWidth
                )
            ) {
                callback()
            }
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deps])
}

export { useOnClickOutside }
